import { getDataClient } from "@/lib/dataClient";
import { useDataQuery, getCurrentUserId } from "@/hooks/useDataQuery";

// Bildirim sistemi veri katmanı.

export interface Notification {
  id: string;
  title: string;
  body: string;
  type: string;
  read: boolean;
  createdAt: string;
}

export const NOTIFICATION_TYPE_ICONS: Record<string, string> = {
  odeme: "ri-bank-card-line",
  odev: "ri-task-line",
  canli: "ri-vidicon-line",
  genel: "ri-notification-3-line",
  general: "ri-notification-3-line",
};

function relativeTime(iso: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const diff = Date.now() - d.getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return "şimdi";
  if (min < 60) return `${min} dk önce`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours} saat önce`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} gün önce`;
  return d.toLocaleDateString("tr-TR", { day: "numeric", month: "short" });
}

export function useNotifications() {
  const query = useDataQuery<Notification[]>(async () => {
    const dataClient = getDataClient();
    const userId = await getCurrentUserId();
    if (!userId) return [];
    const { data, error } = await dataClient
      .from("notifications")
      .select("*")
      .eq("user_id", userId)
      .order("created_at", { ascending: false })
      .limit(20);
    if (error) throw error;
    return (data ?? []).map(
      (n: { id: string; title: string; body: string | null; type: string | null; read: boolean; created_at: string }) => ({
        id: n.id,
        title: n.title,
        body: n.body ?? "",
        type: n.type ?? "general",
        read: n.read ?? false,
        createdAt: relativeTime(n.created_at),
      }),
    );
  });

  const markRead = async (id: string) => {
    const dataClient = getDataClient();
    await dataClient.from("notifications").update({ read: true }).eq("id", id);
    query.reload();
  };

  const markAllRead = async () => {
    const dataClient = getDataClient();
    const userId = await getCurrentUserId();
    if (!userId) return;
    await dataClient.from("notifications").update({ read: true }).eq("user_id", userId).eq("read", false);
    query.reload();
  };

  const unreadCount = (query.data ?? []).filter((n) => !n.read).length;

  return { ...query, markRead, markAllRead, unreadCount };
}